import AccountCard from "./AccountCard"

export default AccountCard
